<template>
  <div
    class="dark:bg-ontick-graphite-500 border-ontick-steel-300 flex flex-col space-y-4 rounded-lg border-2 p-4 dark:border-0"
  >
    <p class="text-lg font-bold">Par</p>

    <!-- ATIVO 1 -->
    <div class="flex items-center space-x-4">
      <ontick-editable-select-component
        :options="symbolList"
        :value="data.symbol1"
        name="symbol1"
        label="Ativo 1"
        @input="
          setData({
            ...$event,
            value: $event.value.toUpperCase(),
          })
        "
        @blur="onBlur"
        :disabled="isEditing"
      />

      <div class="flex items-end space-x-4">
        <div class="flex flex-col space-y-1">
          <label for="financeiro1" class="text-sm"> Financeiro </label>

          <input
            class="input disabled:border-gray-500"
            name="financeiro1"
            :disabled="
              data.volumeType !== 'FIN_VOLUME' ||
              isRunning ||
              data.symbol1.length < 5
            "
            :value="data.symbol1FinVolume"
            @input="
              deferData({
                prop: 'symbol1FinVolume',
                value: $event.target.value,
              })
            "
            @keypress="preventNegative"
            v-money="money"
          />
        </div>

        <button
          class="border-ontick-steel-300 dark:bg-ontick-steel-500 text-ontick-blue-600 dark:disabled:bg-ontick-steel-500 -translate-y-2 transform rounded border-2 p-1 disabled:cursor-not-allowed disabled:border disabled:border-gray-500 disabled:bg-gray-500 disabled:text-gray-400 dark:border-0"
          :disabled="isEditing"
          @click.prevent="
            setData({
              prop: 'volumeType',
              value:
                data.volumeType === 'FIN_VOLUME' ? 'QUANTITY' : 'FIN_VOLUME',
            })
          "
        >
          <div class="rotate-90 transform">
            <i v-html="$icons.swap"></i>
            <span class="sr-only"> Alternar tipo de volume </span>
          </div>
        </button>

        <div class="flex flex-col space-y-1">
          <label for="volume1" class="text-sm"> Quantidade </label>
          <input
            type="number"
            class="input"
            name="volume1"
            :value="
              data.volumeType === 'FIN_VOLUME'
                ? getQtdFromFin1
                : data.symbol1QtdVolume
            "
            :disabled="
              data.volumeType === 'FIN_VOLUME' || data.symbol1.length < 5
            "
            @input="
              setData({
                prop: 'symbol1QtdVolume',
                value: parseInt($event.target.value),
              })
            "
            @blur="normalize('symbol1QtdVolume', 1)"
          />
          <!-- <ontick-editable-select-component
            :options="symbol1QuantityOptions"
            :value="
              data.volumeType === 'FIN_VOLUME'
                ? getQtdFromFin1
                : data.symbol1QtdVolume
            "
            :acceptInput="true"
            name="symbol1QtdVolume"
            label="Quantidade"
            @input="
              setData({
                ...$event,
                value: $event.value,
              })
            "
            :disabled="
              data.volumeType === 'FIN_VOLUME' || data.symbol1.length < 5
            "
          /> -->
        </div>
      </div>
    </div>

    <!-- ATIVO 2 -->
    <div class="flex items-start space-x-4">
      <ontick-editable-select-component
        :options="symbolList"
        :value="data.symbol2"
        name="symbol2"
        label="Ativo 2"
        @input="
          setData({
            ...$event,
            value: $event.value.toUpperCase(),
          })
        "
        @blur="onBlur"
        :disabled="isEditing"
      />

      <div class="flex items-start space-x-4">
        <div class="flex flex-col space-y-1">
          <label for="financeiro2" class="text-sm"> Financeiro </label>

          <!-- <input
            class="input"
            name="financeiro2"
            ref="financeiro2"
            disabled
            :placeholder="$filters.currency(data.symbol1FinVolume)"
            :options="{ currency: 'BRL' }"
          /> -->
          <input
            class="input disabled:border-gray-500"
            name="financeiro2"
            disabled
            :placeholder="data.symbol1FinVolume"
          />
        </div>

        <button
          class="bg-ontick-steel-500 pointer-events-none -translate-y-2 transform rounded p-1 opacity-0"
        >
          <div class="rotate-90 transform">
            <i v-html="$icons.swap" class="text-ontick-blue-600"></i>
          </div>
        </button>
        <div class="flex flex-col space-y-1">
          <label for="volume2" class="text-sm"> Quantidade </label>

          <input
            type="number"
            class="input"
            name="volume2"
            :value="
              data.volumeType === 'FIN_VOLUME'
                ? getQtdFromFin2
                : data.symbol2QtdVolume
            "
            :disabled="
              data.volumeType === 'FIN_VOLUME' || data.symbol2.length < 5
            "
            @input="
              setData({
                prop: 'symbol2QtdVolume',
                value: parseInt($event.target.value),
              })
            "
            @blur="normalize('symbol2QtdVolume', 2)"
          />

          <!-- <ontick-editable-select-component
            :options="symbol2QuantityOptions"
            :value="
              data.volumeType === 'FIN_VOLUME'
                ? getQtdFromFin2
                : data.symbol2QtdVolume
            "
            :acceptInput="false"
            name="symbol2QtdVolume"
            label="Quantidade"
            @input="
              setData({
                ...$event,
                value: $event.value,
              })
            "
            :disabled="
              data.volumeType === 'FIN_VOLUME' || data.symbol2.length < 5
            "
          /> -->
        </div>
      </div>
    </div>

    <ontick-editable-select-component
      :options="operationTypes"
      :value="data.operationType"
      :acceptInput="false"
      name="operationType"
      label="Tipo de operação"
      @input="
        setData({
          ...$event,
          value: $event.value,
        })
      "
      :disabled="
        isEditing || data.symbol1.length < 5 || data.symbol2.length < 5
      "
    />
    <div class="flex flex-col gap-1 text-sm" v-if="displaySummary">
      <span>Resumo</span>
      <div
        class="bg-ontick-carbon-500 divide-ontick-steel-500 flex w-full flex-col divide-y rounded text-xs"
      >
        <div class="flex items-center justify-between p-2">
          <div class="flex items-center gap-2">
            <div
              class="text-ontick-graphite-500 flex h-5 min-w-[20px] items-center justify-center rounded bg-[#B9AB30] text-[10px] font-bold"
              :content="data.operationType === 'Compra' ? 'Compra' : 'Venda'"
              v-tippy="{ arrow: true, theme: 'green' }"
            >
              {{ data.operationType.charAt(0) }}
            </div>
            <span>
              {{ data.symbol1 }}
            </span>
          </div>
          <div class="flex items-center gap-2">
            <span class="whitespace-nowrap">
              {{
                data.volumeType === "QUANTITY"
                  ? data.symbol1QtdVolume
                  : getQtdFromFin1
              }}
              x {{ data.symbol1Price | currency }} =
            </span>
            <template v-if="data.volumeType === 'FIN_VOLUME'">
              <span
                v-if="data.operationType === 'Compra'"
                class="whitespace-nowrap"
                :class="[
                  {
                    'text-ontick-green-600':
                      getQtdFromFin1 * data.symbol1Price * -1 > 0,
                  },
                  {
                    'text-ontick-red-600':
                      getQtdFromFin1 * data.symbol1Price * -1 < 0,
                  },
                ]"
              >
                {{ (getQtdFromFin1 * data.symbol1Price * -1) | currency }}
              </span>
              <span
                v-else
                class="whitespace-nowrap"
                :class="[
                  {
                    'text-ontick-green-600':
                      getQtdFromFin1 * data.symbol1Price > 0,
                  },
                  {
                    'text-ontick-red-600':
                      getQtdFromFin1 * data.symbol1Price < 0,
                  },
                ]"
              >
                {{ (getQtdFromFin1 * data.symbol1Price) | currency }}
              </span>
            </template>
            <template v-else>
              <span
                v-if="data.operationType === 'Compra'"
                class="whitespace-nowrap"
                :class="[
                  {
                    'text-ontick-green-600':
                      data.symbol1QtdVolume * data.symbol1Price * -1 > 0,
                  },
                  {
                    'text-ontick-red-600':
                      data.symbol1QtdVolume * data.symbol1Price * -1 < 0,
                  },
                ]"
              >
                {{
                  (data.symbol1QtdVolume * data.symbol1Price * -1) | currency
                }}
              </span>
              <span
                v-else
                class="whitespace-nowrap"
                :class="[
                  {
                    'text-ontick-green-600':
                      data.symbol1QtdVolume * data.symbol1Price > 0,
                  },
                  {
                    'text-ontick-red-600':
                      data.symbol1QtdVolume * data.symbol1Price < 0,
                  },
                ]"
              >
                {{ (data.symbol1QtdVolume * data.symbol1Price) | currency }}
              </span>
            </template>
          </div>
        </div>
        <div class="flex items-center justify-between p-2">
          <div class="flex items-center gap-2">
            <div
              class="text-ontick-graphite-500 flex h-5 min-w-[20px] items-center justify-center rounded bg-[#B9AB30] text-[10px] font-bold"
              :content="data.operationType === 'Compra' ? 'Venda' : 'Compra'"
              v-tippy="{ arrow: true, theme: 'green' }"
            >
              {{ data.operationType === "Compra" ? "V" : "C" }}
            </div>
            <span>
              {{ data.symbol2 }}
            </span>
          </div>
          <div class="flex items-center gap-2">
            <span class="whitespace-nowrap">
              {{
                data.volumeType === "QUANTITY"
                  ? data.symbol2QtdVolume
                  : getQtdFromFin2
              }}
              x {{ data.symbol2Price | currency }} =
            </span>
            <template v-if="data.volumeType === 'FIN_VOLUME'">
              <span
                v-if="data.operationType === 'Venda'"
                class="whitespace-nowrap"
                :class="[
                  {
                    'text-ontick-green-600':
                      getQtdFromFin2 * data.symbol2Price * -1 > 0,
                  },
                  {
                    'text-ontick-red-600':
                      getQtdFromFin2 * data.symbol2Price * -1 < 0,
                  },
                ]"
              >
                {{ (getQtdFromFin2 * data.symbol2Price * -1) | currency }}
              </span>
              <span
                v-else
                class="whitespace-nowrap"
                :class="[
                  {
                    'text-ontick-green-600':
                      getQtdFromFin2 * data.symbol2Price > 0,
                  },
                  {
                    'text-ontick-red-600':
                      getQtdFromFin2 * data.symbol2Price < 0,
                  },
                ]"
              >
                {{ (getQtdFromFin2 * data.symbol2Price) | currency }}
              </span>
            </template>
            <template v-else>
              <span
                v-if="data.operationType === 'Venda'"
                class="whitespace-nowrap"
                :class="[
                  {
                    'text-ontick-green-600':
                      data.symbol2QtdVolume * data.symbol2Price * -1 > 0,
                  },
                  {
                    'text-ontick-red-600':
                      data.symbol2QtdVolume * data.symbol2Price * -1 < 0,
                  },
                ]"
              >
                {{
                  (data.symbol2QtdVolume * data.symbol2Price * -1) | currency
                }}
              </span>
              <span
                v-else
                class="whitespace-nowrap"
                :class="[
                  {
                    'text-ontick-green-600':
                      data.symbol2QtdVolume * data.symbol2Price > 0,
                  },
                  {
                    'text-ontick-red-600':
                      data.symbol2QtdVolume * data.symbol2Price < 0,
                  },
                ]"
              >
                {{ (data.symbol2QtdVolume * data.symbol2Price) | currency }}
              </span>
            </template>
          </div>
        </div>
        <div class="flex items-center justify-between p-2">
          <span> Saldo: </span>
          <span
            :class="[
              {
                'text-ontick-green-600': getBalance > 0,
              },
              {
                'text-ontick-red-600': getBalance < 0,
              },
            ]"
          >
            {{ getBalance | currency }}
          </span>
        </div>
      </div>
    </div>

    <div class="divide-ontick-steel-500 flex items-start divide-x-2">
      <div class="flex w-full flex-col space-y-1 pr-4">
        <div class="flex items-center gap-2">
          <label class="text-sm"> Hora de início </label>
          <ontick-switch
            class="scale-75 transform"
            :active="startDateEnabled"
            @switch="startDateEnabled = !startDateEnabled"
            :disabled="isRunning"
          />
        </div>
        <div
          v-if="startDateEnabled"
          class="long-short-date-picker relative h-10"
        >
          <VueCtkDateTimePicker
            id="startDate"
            label="Data de início"
            locale="pt-BR"
            formatted="DD/MM/YYYY HH:mm:ss"
            format="YYYY-MM-DDTHH:mm"
            :value="data.startDate"
            :dark="getUiTheme === 'DARK' ? true : false"
            :noClearButton="true"
            :no-button-now="true"
            :min-date="moment().format()"
            :disabled-weekly="[0, 6]"
            :no-value-to-custom-elem="true"
            @input="setData({ prop: 'startDate', value: $event })"
            :disabled="!!editInfo.alg_ord_code || isRunning"
          >
          </VueCtkDateTimePicker>
          <span
            class="pointer-events-none absolute inset-y-2.5 right-2"
            v-html="$icons.calendar"
          />
        </div>
      </div>
      <div class="flex w-full flex-col space-y-1 pl-4">
        <div class="flex items-center gap-2">
          <label class="text-sm"> Hora de fechamento </label>
          <ontick-switch
            class="scale-75 transform"
            :active="endDateEnabled"
            @switch="endDateEnabled = !endDateEnabled"
            :disabled="isRunning"
          />
        </div>

        <div v-if="endDateEnabled" class="long-short-date-picker relative h-10">
          <VueCtkDateTimePicker
            id="endDate"
            label="Data de término"
            locale="pt-BR"
            formatted="DD/MM/YYYY HH:mm:ss"
            format="YYYY-MM-DDTHH:mm"
            :value="data.endDate"
            :dark="getUiTheme === 'DARK' ? true : false"
            :noClearButton="true"
            :no-button-now="true"
            :min-date="moment().format()"
            :disabled-weekly="[0, 6]"
            :no-value-to-custom-elem="true"
            @input="setData({ prop: 'endDate', value: $event })"
            :disabled="!!editInfo.alg_ord_code || isRunning"
          >
          </VueCtkDateTimePicker>
          <span
            class="pointer-events-none absolute inset-y-2.5 right-2"
            v-html="$icons.calendar"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import VueCtkDateTimePicker from "vue-ctk-date-time-picker";
import "vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css";
import ontickEditableSelectComponent from "../../../shared/components/basic/ontick-editable-select.component.vue";
import { mapActions, mapGetters } from "vuex";
import { VMoney } from "v-money";

export default {
  directives: { money: VMoney },

  components: {
    VueCtkDateTimePicker,
    ontickEditableSelectComponent,
  },

  props: {
    operationTypes: {
      type: Array,
    },
    editInfo: {
      type: Object,
    },
  },

  data() {
    return {
      symbolList: [],
      startDateEnabled: false,
      endDateEnabled: false,
      editables: [
        "alg_ord_name",
        "alg_ord_description",
        "entry_value",
        "intercept_value",
        "slope_value",
        "tp_value",
        "sl_value",
        "volume",
        "volume_1",
        "volume_2",
        // parâmetros condicionais
        "start_datetime",
        "end_datetime",
      ],
    };
  },

  computed: {
    ...mapGetters({
      getUiTheme: "config/getUiTheme",
      data: "longShort/getData",
      getQtdFromFin1: "longShort/getQtdFromFin1",
      getQtdFromFin2: "longShort/getQtdFromFin2",
      getBalance: "longShort/getBalance",
    }),
    isEditing() {
      return !!this.$route.params.alg_ord_id;
    },
    isRunning() {
      if (this.editInfo?.alg_ord_state) {
        return !["NEW", "FILLED", "STOPPED"].includes(
          this.editInfo.alg_ord_state
        );
      } else {
        return false;
      }
    },
    displaySummary() {
      if (this.data.operationType) {
        if (this.data.volumeType === "FIN_VOLUME") {
          return (
            this.data.symbol1FinVolume !== "R$ 0" &&
            this.data.symbol1 &&
            this.data.symbol2 &&
            this.getQtdFromFin1 &&
            this.getQtdFromFin2
          );
        } else if (this.data.volumeType === "QUANTITY") {
          return (
            this.data.symbol1QtdVolume &&
            this.data.symbol2QtdVolume &&
            this.data.symbol1 &&
            this.data.symbol2
          );
        }
        return false;
      }
      return false;
    },
    symbol1QuantityOptions() {
      let arr = [];
      for (let i = 0; i < 20; i++) {
        arr.push({
          label: String(this.data.symbol1Step * (i + 1)),
          value: this.data.symbol1Step * (i + 1),
        });
      }
      return arr;
    },
    symbol2QuantityOptions() {
      let arr = [];
      for (let i = 0; i < 20; i++) {
        arr.push({
          label: String(this.data.symbol2Step * (i + 1)),
          value: this.data.symbol2Step * (i + 1),
        });
      }
      return arr;
    },
  },

  methods: {
    ...mapActions({
      setData: "longShort/setData",
      checkSymbols: "longShort/checkSymbols",
      clearVolumes: "longShort/clearVolumes",
    }),
    normalize(prop, symbol_number) {
      if (
        this.data[`symbol${symbol_number}QtdVolume`] <
        this.data[`symbol${symbol_number}Step`]
      ) {
        this.setData({
          prop,
          value: this.data[`symbol${symbol_number}Step`],
        });
        return;
      }
      this.setData({
        prop,
        value:
          this.data[`symbol${symbol_number}QtdVolume`] -
          (this.data[`symbol${symbol_number}QtdVolume`] %
            this.data[`symbol${symbol_number}Step`]),
      });
    },
    preventNegative(event) {
      if (event.key === "-") event.preventDefault();
    },
    deferData(obj) {
      this.$nextTick(() => {
        this.setData(obj);
      });
    },
    getSymbols() {
      this.$api
        .get(this.$endpoint.LIST_ALGO_ORDER_SYMBOLS)
        .then((res) => {
          // console.log(res.data);
          this.symbolList = res.data.map((item) => {
            return {
              label: item,
              value: item,
            };
          });
        })
        .catch((err) => {
          console.error(err);
        });
    },
    onBlur() {
      if (this.data.method) {
        this.checkSymbols();
      }
    },
  },

  watch: {
    startDateEnabled: {
      handler(val) {
        if (val) {
          this.setData({
            prop: "startDate",
            value: this.moment().format(),
          });
        } else {
          this.setData({ prop: "startDate", value: "" });
        }
      },
    },
    "data.volumeType": {
      handler(val) {
        this.clearVolumes(val);
      },
    },
  },

  mounted() {
    this.getSymbols();
    if (this.isEditing) {
      this.startDateEnabled = true;
      this.endDateEnabled = true;
    }
  },
};
</script>

<style lang="scss" scoped>
.input {
  @apply border-ontick-steel-300 dark:bg-ontick-carbon-500 dark:disabled:bg-ontick-steel-500 h-10 w-full rounded border-2 px-2 text-sm shadow disabled:cursor-not-allowed disabled:border disabled:bg-gray-400 dark:border-0 dark:disabled:text-gray-500;
}
</style>
